//统一管理api
import { base_cf } from "./base"; // 导入接口域名列表
import { get } from "./tool"; // 导入http中创建的axios实例

export const getCountry = () => get(base_cf + "/country");

export default {
    getCountry,
};
